import logger from '3-foundation/Logging/logger';
import { mapContentSection } from './PageSections/ContentSectionMapper';
import { mapAnchor } from './PageSections/anchorMapper';
import { mapTabs } from './PageSections/tabsMapper';

const pageSectionMappers: Record<string, ({ content, settings, siteId, locale }) => Promise<Content.ContentSection | Content.Tabs | Content.Anchor>> =
	{
		contentSection: mapContentSection,
		tabs: mapTabs,
		anchor: mapAnchor,
	};

export const mapPageSections = async (
	items: Umbraco.ContentModule[],
	siteId?: string,
	locale?: string,
): Promise<(Content.ContentSection | Content.Tabs | Content.Anchor)[]> => {
	try {
		return await Promise.all(
			items.map(async (item) => {
				const mapper = pageSectionMappers[item.content?.contentType];
				if (mapper) {
					return await mapper({ content: item.content, settings: item.settings, siteId, locale });
				} else {
					logger.error(`No page section mapper found for content type: ${item.content?.contentType}`);
					throw new Error(`No page section mapper found for content type: ${item.content?.contentType}`);
				}
			}),
		);
	} catch (error) {
		logger.error(`Could not map PageSections \nCause: ${error}`);
		throw new Error(`Could not map PageSections \nCause: ${error}`, { cause: error });
	}
};
